// removed by extract-text-webpack-plugin
module.exports = {"ccpa":"privacy_ccpa-main_ccpa","title":"privacy_ccpa-main_title","description":"privacy_ccpa-main_description","sectionTitle":"privacy_ccpa-main_sectionTitle","sectionDescription":"privacy_ccpa-main_sectionDescription","sectionIndentedDescription":"privacy_ccpa-main_sectionIndentedDescription"};


//////////////////
// WEBPACK FOOTER
// ../node_modules/@cube/privacy-widgets/src/components/ccpa-main/style.less
// module id = 585
// module chunks = 9 12